import List from '@utils/list'
import { Dialog, Select } from '@utils/index'
import { Options } from '@utils/index'
// import getData from './config/getData'
import chacuo from './components/chacuo.vue'
import { tableExport } from '@utils/index'
// import looktotal from './components/looktotal.vue'
import http from '@/plugin/axios'
import tabsvue from './components/tabs.vue'
import lookdialog from './components/dialog.vue'
import zonglantable from './components/zonglantable.vue'
import { getBillDetail, getBillDetailSum } from '@/api/bill/index'
// import operation from './config/operation'
import CheckboxSelect from '@/components/select/checkbox-select/checkbox-select.vue'
const { Search, Jurisdiction, Table, Tabs, Operation } = List
const dialog = new Dialog('bill.table')
  .title('discrepantdata')
  .component(lookdialog)
const allofdialog = new Dialog('bill.table')
  .title('xiangqingData')
  .component(zonglantable)
const select = Select.copy('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1' })

function lookDialog(this: any, row: any) {
  if (this.btn === '1') {
    allofdialog.open({ attrs: { data: row, this: this }})
  } else {
    dialog.open({ attrs: { data: row }}).then(async(value: any) => {
      value.data.diffReason = value.$children[0].value
      value.data.supConfirmSign = value.data.supConfirmSign === 'Y' ? 'N' : 'Y'
      await http({
        url: '/srmOutBill/updateOrInsertBillStatus',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: [value.data]
      })
    })
  }
}
function exportTable(this: any) {
  tableExport({
    name: this.$t('bill.table.dayin'),
    url: '/srmOutBill/exportOutBill',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: this.getCondition()
  })
}
async function OK(this: any, row: any) {
  console.log(row)
  await this.$confirm(this.$t('bill.table.yesnoOk')) // 是否确认
  row.supConfirmSign = row.supConfirmSign === 'Y' ? 'N' : 'Y'
  await http({
    url: '/srmOutBill/updateOrInsertBillStatus',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: [row]
  })
  this.refresh()
}
function showFlag(row: any) {
  return row.$page.btn === '0'
}
function showFlag1(row: any) {
  return row.$page.btn === '1'
}
async function batchOK(this: any) {
  for (let i = 0; i < this.selection.length; i++) {
    if (this.selection[i].supConfirmSign === 'Y') {
      return this.$message({
        message: '已经确认的订单无法再次确认!',
        type: 'warning'
      })
    }
  }
  await this.$confirm(this.$t('bill.table.yesnoOk'))
  const row = this.selection.map((ele: any) => {
    ele.supConfirmSign = 'N'
    return ele
  })
  await http({
    url: '/srmOutBill/updateOrInsertBillStatus',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: row
  })
  this.refresh()
}

const operation = new Operation('bill.table')
  .add('lookinfo').label('lookinfo').width(150).handle(lookDialog)
  .add('OK').label('OK').handle(OK).width(150).show(
    (item: any) => { const a = item.purConfirmSign + item.supConfirmSign; return item.purConfirmSign === 'N' && a !== 'YY' })
  .add('NOOK').label('NOOK').handle(OK).show(
    (item: any) => { const a = item.purConfirmSign + item.supConfirmSign; return item.purConfirmSign === 'Y' && a !== 'NN' })
// const tabOptions = [{ difference: $t('bill.table.all'), status: '' }, { difference: $t('bill.table.noaffirm'), status: 'N' }, { difference: $t('bill.table.yesaffirm'), status: 'Y' }]
const tabs = new Tabs()
  // .api(() => Promise.resolve(tabOptions))
  .btn({
    default: '0',
    btns: [
      { text: 'bill.table.cuttabs[0]', value: '0' },
      { text: 'bill.table.cuttabs[1]', value: '1' }
    ]
  })
  .template(tabsvue)
  .name('difference')
  .prop('supConfirmSign')

const option = new Options('bill.table')
  .add('N', 'datadifference[0]')
  .add('Y', 'datadifference[1]')
console.log(option)
const extra = new Search('bill.table')
  .add('invoiceSign').label('').component(CheckboxSelect).bind('text', 'bill.table.invoiceSign').default('N')
  .add('diffSign').label('').component(CheckboxSelect).bind('text', 'bill.table.diffSign').default('N')
  // .add('looktotal').label('').component(CheckboxSelect).bind('text', 'bill.table.looktotal').default('N')
const search = new Search('bill.table')
  .placeholder('bill.table.palce')
  .searchOnExtraChange()
  .add('purchaseUnitNo').select(select)
  // .lib('dateRange').prop(['purCheckReceiptDateStart', 'purCheckReceiptDateEnd']).label('docDate').br()
  .add('sourceNo')
  .add('costDateStart').merge('date').label('goData')
  .add('costDateEnd').merge('date').label('endData')
  .extra(extra)
const jurisdiction = new Jurisdiction('bill.table')
  .lib('issueAnInvoice').show(function(this: any) {
    return this.btn === '0'
  })
  .add('import').icon('icon-daoru').sort(10).show(function(this: any) {
    return this.btn === '0'
  }).handle(exportTable)
  .add('manual').icon('icon-querendingdan').sort(20).disabled((selection) => !selection.length).handle(batchOK).show(function(this: any) {
    return this.btn === '0'
  })
const table = new Table('bill.table')
  .edit(true)
  .type('selection')
  .add('costDate').sort(true).show(showFlag)
  .add('purchaseUnitName').show(showFlag1).sort(false)
  .add('purchaseNo').show((row: any) => {
    return row.$page.btn === '0' || row.$page.purchaseSumSign === 'Y'
  })
  .add('pucsscxx').sort(false).html(({ row }) => `${row.purchaseSeq}-${row.purchasePhaseSeq}-${row.purchaseBatchSeq}`).show(showFlag)
  .add('goodsNo').sort(false).show((row: any) => {
    return row.$page.btn === '0' || row.$page.goodsSumSign === 'Y'
  })
  .add('goodsName').sort(false).show((row: any) => {
    return row.$page.btn === '0' || row.$page.goodsSumSign === 'Y'
  })
  .add('batchPurQty').sort(false).show(showFlag)
  .add('asnNo').sort(false).width(180).show((row: any) => {
    return row.$page.btn === '0' || row.$page.asnSumSign === 'Y'
  })
  .add('asnSeq').sort(false).show(showFlag)
  // .add('purchaseNo').show((row: any) => {
  //   return row.$page.btn === '1' && row.$page.purchaseSumSign === 'Y'
  // })
  // .add('unInvoiceQty').show(showFlag) // 可开票对账数量
  // =====================
  .add('PurTaxPrice').html((row: any) => `${row.row.minPurUnTaxPrice}-${row.row.maxPurUnTaxPrice}`).show(showFlag1).sort(false)
  .add('purNoTaxAmount').show(showFlag1).sort(false)
  .add('minPurTaxPrice').html((row: any) => `${row.row.minPurTaxPrice}-${row.row.maxPurTaxPrice}`).show(showFlag1).sort(false)
  .add('purTaxAmount').show(showFlag1).sort(false)
  .add('minStoreUnTaxPrice').html((row: any) => `${row.row.minStoreUnTaxPrice}-${row.row.maxStoreUnTaxPrice}`).show(showFlag1).sort(false)
  .add('storeNoTaxAmount').show(showFlag1).sort(false)
  .add('minStoreTaxPrice').html((row: any) => `${row.row.minStoreTaxPrice}-${row.row.maxStoreTaxPrice}`).show(showFlag1).sort(false)
  .add('storeTaxAmount').show(showFlag1).sort(false)
  // ========================
  .add('sourceNo').sort(true).show(showFlag)
  .add('sourceSeq').sort(false).show(showFlag)
  .add('deliveryQty').sort(false).show(showFlag)
  .add('receiveQty').sort(false).show(showFlag)
  .add('checkReturnQty').sort(false).show(showFlag)
  .add('inStoreQty').show(showFlag)
  .add('normality').sort(false).show(row => row.diffSign === 'N').label('chacuo')
  .add('chacuo').sort(false).editor({ component: chacuo }).show(showFlag)
  .operation(operation).width(250)
  // .html((row: any) => `<span v-if='${row.row.diffSign === 'Y'}' style="color:#E6424F">异常数据</span><span v-if='${row.row.diffSign === 'N'}'>正常数据</span>`) // 差错
  .add('duizhang').sort(false).format((row: any) => {
    if (row.row.purConfirmSign === 'Y' && row.row.supConfirmSign === 'N') {
      return '采购商已确认'
    } else if (row.row.purConfirmSign === 'N' && row.row.supConfirmSign === 'Y') {
      return '供应商已确认'
    } else if (row.row.purConfirmSign === 'Y' && row.row.supConfirmSign === 'Y') {
      return '双方已确认'
    } else if (row.row.purConfirmSign === 'N' && row.row.supConfirmSign === 'N') {
      return '双方未确认'
    }
  }).show(showFlag)
  .add('kaipiao').sort(false).format((row: any) => { // 开票
    if (row.row.invoiceSign === 'Y') {
      return '已开票'
    } else {
      return '未开票'
    }
  }
  ).show(showFlag)
  // .add('opction').sort(false).editor({ component: opt })
async function api(this: any, data: any) { // 总览和明细的切换
  // console.log(this) // this是组件实例
  // console.log(data) // data是模糊搜索的数据
  data.condition.ent = 'SP2'
  data.condition.siteList = ['SP2']
  if (this.btn === '0') {
    const info = await getBillDetail(data)
    return info
  } else {
    data.condition.supSumSign = 'N'
    if (data.condition.supConfirmSign) {
      for (let index = 0; index < data.condition.supConfirmSign.length; index++) {
        data.condition[data.condition.supConfirmSign[index]] = 'Y'
      }
    }
    delete data.condition.supConfirmSign
    const info = await getBillDetailSum(data) // 待定
    return info
  }
}
const list = new List()
  // .operation(operation)
  .api(api)
  .jurisdiction(jurisdiction)
  .search(search)
  .tabs(tabs)
  .table(table)

list.mixins = {
  data() {
    return {
      supSumSign: null,
      goodsSumSign: null,
      purchaseSumSign: null,
      asnSumSign: null,
      zonglanList: []
    }
  }
}
export default list.end()
